import styles from './Body.module.css';
const Body = (props) => {
    return (<div class={styles.body}>
      {props.children}
    </div>);
};
export default Body;
